import React from "react";

/**
 * @typedef {Object} ActivityTimelineEvent
 * @property {string} id
 * @property {React.ReactNode} label
 * @property {string} [actor] - display string for who performed the event (caller resolves e.g. actor_email || "system")
 * @property {string|Date} at - ISO string or Date
 */

/**
 * @typedef {Object} ActivityTimelineProps
 * @property {ActivityTimelineEvent[]} events
 * @property {string} [emptyMessage]
 */

/**
 * Presentation-only left-border timeline. Extracted from Practice.jsx's
 * client-detail "Activity timeline" card — the Card/heading chrome stays
 * with the caller, this component is just the list.
 * @param {ActivityTimelineProps} props
 */
export default function ActivityTimeline({ events, emptyMessage = "Timeline is empty." }) {
  if (!events || events.length === 0) {
    return <div className="text-sm text-muted-foreground">{emptyMessage}</div>;
  }
  return (
    <ol className="relative border-l border-border pl-4 space-y-3">
      {events.map((e) => (
        <li key={e.id} className="relative">
          <span className="absolute -left-[22px] top-1 h-3 w-3 rounded-full bg-primary/70 ring-4 ring-background" aria-hidden="true" />
          <div className="text-sm">{e.label}</div>
          <div className="text-xs text-muted-foreground">
            {e.actor || "system"} · <time dateTime={new Date(e.at).toISOString()}>{new Date(e.at).toLocaleString()}</time>
          </div>
        </li>
      ))}
    </ol>
  );
}
